import { BottomNavigationStack } from './bottom-navigation-stack';

interface StackHistoryItem {
    url: string;
    stack: BottomNavigationStack;
}

export class NavigationStackHistoryState {
    private readonly history: StackHistoryItem[] = [];
    private currentIndex = 0;

    private get current(): StackHistoryItem {
        return this.history[this.currentIndex];
    }

    private get previous(): StackHistoryItem | null {
        if (this.currentIndex <= 0) {
            return null;
        }
        return this.history[this.currentIndex - 1];
    }

    private get next(): StackHistoryItem | null {
        if (this.currentIndex >= history.length) {
            return null;
        }
        return this.history[this.currentIndex + 1];
    }

    public init(initialUrl: string, initialStack: BottomNavigationStack): void {
        this.history.push({ url: initialUrl, stack: initialStack });
    }

    public changeUrl(url: string, currentStack: BottomNavigationStack, isBrowserNav: boolean): BottomNavigationStack {
        if (this.current.url === url) {
            return this.current.stack;
        }

        if (!isBrowserNav) {
            this.history.splice(this.currentIndex + 1);
            this.history.push({ url, stack: currentStack });
            this.currentIndex = this.history.length - 1;
            return this.current.stack;
        }

        if (url === this.next?.url) {
            this.currentIndex++;
        } else if (url === this.previous?.url) {
            this.currentIndex--;
        }

        return this.current.stack;
    }
}
